import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { MagentoCopySource } from 'app/model/pipeline/copysource/magento.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MagentoCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class MagentoCopySourceAdapter extends CopySourceAdapter<MagentoCopySource, Model.MagentoSource> {
    protected override async _toResource(copySource: MagentoCopySource): Promise<Model.MagentoSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(MagentoCopySource).name);
    }

    protected override async _toModel(
        resource: Model.MagentoSource,
        copyActivity: CopyActivity
    ): Promise<MagentoCopySource> {
        return this._toTabularModel(resource, copyActivity, MagentoCopySource.MODEL);
    }
}
